export const getRandomHexColor = () => {
  const randomColor = Math.floor(Math.random() * 0xffffff);
  return `#${randomColor.toString(16).padStart(6, '0')}`;
};

export const CHART_COLORS = [
  "#2858cc", "#47b28d", "#e589da", "#28ccb0", "#b28147", "#a089e5",
  "#2fcc28", "#b2476b", "#89c3e5", "#85b247", "#9c47b2", "#89e5b7",
  "#cc4a28", "#4750b2", "#ace589", "#cc2895", "#47aeb2", "#e5ce89",
  "#7328cc", "#47b258", "#e58995", "#286dcc", "#93b247", "#e589e5",
  "#28cc9b", "#b27347", "#9489e5", "#44cc28", "#b24778", "#89cee5",
  "#ccc428", "#8e47b2", "#89e5ab", "#cc3528", "#475eb2", "#b8e589",
  "#cc28aa", "#47b2a9", "#e5c289", "#5e28cc", "#47b24b", "#e589a1",
  "#2882cc", "#a1b247", "#d989e5", "#28cc87", "#b26547", "#898ae5",
  "#59cc28", "#b24786", "#89dae5", "#ccaf28", "#0e0813ff", "#89e5a0",
  "#cc2830", "#476bb2", "#c3e589", "#cc28bf", "#47b29b", "#e5b689",
  "#4928cc", "#51b247", "#e589ac", "#2896cc", "#aeb247", "#cd89e5",
  "#28cc72", "#b25847", "#8995e5", "#6ecc28", "#b24794", "#89e5e4",
  "#cc9a28", "#7247b2", "#89e594", "#cc2845", "#4779b2", "#cfe589",
  "#c328cc", "#becc28", "#e5ab89", "#3428cc", "#5eb247", "#e589b8",
  "#28abcc", "#b2a847", "#c289e5", "#28cc5d", "#b24a47", "#89a1e5",
  "#83cc28", "#b247a1", "#89e5d8", "#cc8628", "#6547b2", "#8ae589",
  "#cc285a", "#4787b2", "#dbe589", "#ae28cc", "#47b280", "#e59f89",
  "#2831cc", "#6cb247", "#e589c4", "#28c0cc", "#b29a47", "#b689e5",
  "#28cc48", "#b24751", "#89ade5", "#97cc28", "#b247af", "#89e5cd",
  "#cc7128", "#5747b2", "#96e589", "#cc286f", "#4794b2", "#e5e489",
  "#9928cc", "#47b272", "#e59389", "#2846cc", "#7ab247", "#e589d0",
  "#28ccc2", "#b28d47", "#aa89e5", "#28cc33", "#b2475f", "#89b9e5",
  "#accc28", "#a747b2", "#89e5c1", "#cc5c28", "#4947b2", "#a2e589",
  "#cc2884", "#47a2b2", "#e5d889", "#8528cc", "#47b264", "#e5898b",
  "#285bcc", "#87b247", "#e589db", "#28ccad", "#b27f47", "#9e89e5",
  "#32cc28", "#b2476d", "#89c4e5", "#c1cc28", "#9a47b2", "#89e5b5",
  "#cc4728", "#4752b2", "#aee589", "#cc2898", "#47b0b2", "#e5cc89",
  "#7028cc", "#47b256", "#e58997", "#2870cc", "#95b247", "#e389e5",
  "#28cc98", "#b27147", "#9389e5", "#47cc28", "#b2477a", "#89d0e5",
  "#ccc128", "#8c47b2", "#89e5aa", "#cc3228", "#4760b2", "#b9e589",
  "#cc28ad", "#47b2a7", "#e5c089", "#5b28cc", "#47b249", "#e589a2",
  "#2885cc", "#a3b247", "#d789e5", "#28cc83", "#b26347", "#898be5",
  "#5ccc28", "#b24788", "#89dce5", "#ccac28", "#7e47b2", "#89e59e",
  "#cc2833", "#476db2"
];